import { render, staticRenderFns } from "./Newsletter.vue?vue&type=template&id=0fe44442&"
import script from "./Newsletter.vue?vue&type=script&lang=ts&"
export * from "./Newsletter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseInput: require('/app/components/base/Input.vue').default,BaseFormItem: require('/app/components/base/FormItem.vue').default,BaseButton: require('/app/components/base/Button.vue').default,AppNoty: require('/app/components/app/Noty.vue').default,BaseForm: require('/app/components/base/Form.vue').default})
